import I18n from 'I18n';
export function getLanguageName(lang) {
  return I18n.lookup(`i18nAddon.languages.${lang}`) ? I18n.text(`i18nAddon.languages.${lang}`) : lang;
}
export function getDefaultTranslatedFormName(formName, lang) {
  return `${formName} [${getLanguageName(lang)}]`;
}